
        import 'Pdf.467461b.css-module'
        export default {"pdf":"pdf_Pdf_467461b"}
    